<template>
  <section id="offices" :class="`offices ${className}`" :aria-labelledby="scrollToId">
    <h2 :id="scrollToId" class="offices__title">{{ title }}</h2>
    <div class="offices__wrapper" role="list" aria-label="Toimipisteet">
      <header v-if="offices?.length > 1 && !areBusinessAreaOffices" class="offices__selectors">
        <div class="offices__tabs">
          <div
            data-value="-1"
            :class="`office-tab ${officeId === '-1' ? 'selected' : ''}`"
            tabindex="0"
            @click="selectOffice('-1')"
            @keydown.enter.prevent="selectOffice('-1')"
          >
            <span>Kaikki toimipisteet</span>
            <i class="icon-chevron-right"></i>
          </div>
          <div
            v-for="office in offices"
            :key="`office-${office.id}`"
            :class="`office-tab ${officeId.toString() === office.id.toString() ? 'selected' : ''}`"
            tabindex="0"
            @click="selectOffice(office.id)"
            @keydown.enter.prevent="selectOffice(office.id)"
          >
            <span>{{ office.name }}</span>
            <i class="icon-chevron-right"></i>
          </div>
        </div>

        <select v-model="officeId" class="offices__dropdown form-dropdown" @change="selectOffice(officeId)">
          <option value="-1">Kaikki toimipisteet</option>
          <option v-for="office in offices" :key="`other-office-${office.id}`" :value="office.id">
            {{ office.name }}
          </option>
        </select>
      </header>
      <template v-if="areBusinessAreaOffices">
        <template v-for="office in offices">
          <business-area-office
            v-if="shouldShowOffice(office.id)"
            :key="`business-area-office-${office.id}`"
            :office="office"
            role="listitem"
          />
        </template>
      </template>
      <template v-else>
        <template v-for="office in offices">
          <office
            v-if="shouldShowOffice(office.id)"
            :key="`personnel-link-office-${office.id}`"
            :agency-id="agencyId"
            :office="office"
          />
        </template>
      </template>
    </div>
  </section>
</template>
<script lang="ts">
import Office from './office.vue';
import BusinessAreaOffice from './business-area-office.vue';
import VueScrollTo from 'vue-scrollto';
import { defineComponent } from 'vue';
import { getRouteParamAsString } from '@/app/composables/useSafeRoute';

export default defineComponent({
  name: 'Offices',
  components: {
    Office,
    BusinessAreaOffice,
  },
  props: {
    agencyId: {
      type: Number,
      required: false,
    },
    offices: {
      type: Array as () => Array<any>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      required: false,
    },
    areBusinessAreaOffices: {
      type: Boolean,
      required: false,
      default: false,
    },
    scrollToId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    officeId: '-1',
  }),
  watch: {
    offices() {
      this.officeId = '-1';
    },
  },
  mounted() {
    const office = getRouteParamAsString(this.$route.query.office);
    this.officeId = office ? office : '-1';

    if ('contact' in this.$route.query) {
      const duration = 400;
      const options = {
        easing: 'ease-out',
        offset: -100,
        cancelable: true,
      };
      VueScrollTo.scrollTo(document.getElementById('offices'), duration, options);
    }
  },
  methods: {
    shouldShowOffice(id: string | number) {
      return this.officeId === '-1' || this.officeId === id.toString();
    },
    setURL(url: string) {
      history.pushState({}, '', url);
    },
    setURLParams(id: string, shouldShowAll?: boolean) {
      if (shouldShowAll) {
        this.setURL(this.$route.path);
      } else {
        this.setURL(this.$route.path + '?office=' + id);
      }
    },
    selectOffice(id: string | number) {
      this.officeId = id.toString();

      if (id !== '-1') {
        this.setURLParams(id.toString());
      } else {
        this.setURLParams(id, true);
      }
    },
  },
});
</script>
